import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const loginMagicLinkReducer = createReducer<State, Actions>(initialState, {
  [actions.loginMagicLink.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.loginMagicLink.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.loginMagicLink.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.loginMagicLink.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default loginMagicLinkReducer;
